
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/speed-grader/jst/-turnitinInfo';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <div class=\"turnitin_resubmit_container\">\n    <a href=\"#\" class=\"btn btn-small turnitin_resubmit_button\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("turnitin_info")
  },data:data},helper ? helper.call(depth0, "turnitin_info.buttons.resubmit_to_turnitin", "Resubmit", options) : helperMissing.call(depth0, "t", "turnitin_info.buttons.resubmit_to_turnitin", "Resubmit", options)))
    + "</a>\n  </div>\n  ";
  return buffer;
  }

  buffer += "<div class=\"turnitin_info turnitin_";
  if (helper = helpers.assetString) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.assetString); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" style=\"display: none;\">\n  <div>";
  if (helper = helpers.message) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.message); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showResubmit), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/features/speed_grader/jst/_turnitinInfo.handlebars', templates['/var/canvas/ui/features/speed-grader/jst/-turnitinInfo']);
    ;
    ;
    export default templates[name];
  